import React from "react";

import RevealableCopyIcon from "ui/RevealableCopyIcon";

import { useWebhookSigningKeySecretLazyQuery } from "./gql/Query.generated";

// Matching length of revealed secrets
const MASKED_SECRET = "whsec_" + "*".repeat(44);

// Shows errors inline rather than as a flash, so that it also works in a modal,
// where a flash would be hidden behind the overlay
function SigningSecret({
  signingKeyId,
  canReveal,
}: {
  signingKeyId: string;
  canReveal: boolean;
}) {
  // Each reveal is audit-logged, so the secret is fetched on demand and kept out
  // of the Apollo cache
  const [fetchSecret, { data, loading, error }] =
    useWebhookSigningKeySecretLazyQuery({ fetchPolicy: "no-cache" });
  const secret = data?.getWebhookSigningKey.secret;

  const handleReveal = () => {
    if (loading) {
      return;
    }
    void fetchSecret({ variables: { webhookSigningKeyId: signingKeyId } });
  };

  return (
    <div>
      <div className="flex items-center gap-1.5">
        <code className="break-all bg-[#f7fafc] text-[#333]">
          {secret ?? MASKED_SECRET}
        </code>
        {canReveal && (
          <RevealableCopyIcon
            content={secret ?? ""}
            hidden={!secret}
            onReveal={handleReveal}
          />
        )}
      </div>
      {error && (
        <div role="alert" className="text-[#c93a2a]">
          Could not reveal the secret: {error.message}
        </div>
      )}
    </div>
  );
}

export default SigningSecret;
